<template>
  <div class="audio-upload-wrapper">
    <div class="audio-upload">
      <div class="audio-btn-wrappper">
        <div alt="" class="audio-upload-btn_img">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <p class="audio-upload-btn_info">添加音频</p>
      </div>
      <input :disabled=isLoading class="audio-input" type="file" @change="uploadAudio" accept="audio/*, .mp3, .wma, .amr, .wav, .m4a" multiple/>
    </div>
    <div class="audio-list">
      <div v-for="(file, index) in filelist" :key="file.url">
        <AudioPlayer :fileurl=file.url :index=index :fileName=file.name :status=file.status className="player" @remove="remove"/>
      </div>
    </div>
  </div>
</template>
<script>
import AudioPlayer from '../AudioPlayer'
import { ulid } from 'ulid'
import { Toast } from '@zz-common/zz-ui';
export default {
  name: 'SuperviseCommit',
  data() {
    return {
      filelist: [],
      isLoading: false
    };
  },
  computed: {},
  methods: {
    // 限制音频长度
    checkAudioDuration(file) {
      return new Promise((resolve, reject) => {
        const audio = new Audio();
        const objectURL = URL.createObjectURL(file);
        audio.src = objectURL;
        // 清理资源
        const cleanup = () => {
          URL.revokeObjectURL(objectURL); // 释放内存
          audio.removeEventListener('loadedmetadata', handleLoaded);
          audio.removeEventListener('error', handleError);
        };

        // 成功加载元数据
        const handleLoaded = () => {
          const duration = parseInt(audio.duration);
          if (isNaN(duration)) {
            cleanup();
            reject(new Error('无法获取音频时长'));
            Toast('音频格式不支持或文件损坏');
            return;
          }
          const minutes = Math.floor(duration / 60);
          if (minutes > 120) {
            cleanup();
            reject(new Error('音频超过120分钟'));
            Toast('请不要上传超过120分钟的音频!');
          } else {
            cleanup();
            resolve();
          }
        };

        // 处理加载错误
        const handleError = (e) => {
          cleanup();
          reject(new Error('音频加载失败'));
          Toast('无法读取文件，请检查音频格式');
        };

        // 绑定事件监听
        audio.addEventListener('loadedmetadata', handleLoaded);
        audio.addEventListener('error', handleError);
      });
    },
    async uploadAudio(event) {
      const file = event.target.files[0];
      const uid = file.uid || ulid();
      if (this.filelist.length >= 2) {
        Toast('请不要上传超过2条音频!');
        return;
      }
      if (!file.type.startsWith('audio/')) {
        Toast('请上传格式为音频!');
        return;
      }
      this.$emit('changeLoading', true);
      this.isLoading = true;
      const beforeFileList = [...this.filelist]
      this.filelist = [...this.filelist, { status: 'loading', uid }];
      await this.checkAudioDuration(file);
      const formData = new FormData();
      formData.append('multipartFile', file);
      formData.append('originalFormat', file.name);
      formData.append('pathSign', '2dxOi3ErQXu');
      formData.append('sign', window.btoa(new Date().valueOf()).split('').reverse().join(''));
      formData.append('appKey', 'nybg6fx5tAAJIUnT');
      fetch('https://mediaproxy.zhuanzhuan.com/media/cos/uploadObject', {
        method: 'POST',
        credentials: 'include',
        body: formData
      }).then(res => res.json()).then(res => {
        const { readDomain, filePath } = res.respData;
        const curFile = {
          uid,
          status: 'done',
          url: `https://${readDomain}${filePath}`,
          name: file.name
        }
        if (+res.respCode === 0) {
          this.filelist = [...beforeFileList, curFile];
          this.$emit('changeLoading', false);
          this.isLoading = false;
        } else {
          Toast(res.respMsg);
          this.isLoading = false;
        }
      }).catch(err => {
        console.log(err);
      });
    },
    remove(index) {
      this.filelist.splice(index, 1);
    }
  },
  created() {
  },
  components: {
    AudioPlayer
  }
};
</script>

<style lang='less' scoped>
@import "index.less";
</style>
